import { Text } from "components/common/Text";
import React, { FC } from "react";

type Props = {
  teamName: string;
  points: number;
  label: string;
  teamColor: string;
};

export const PointsFlashBanner: FC<Props> = ({
  teamName,
  points,
  label,
  teamColor,
}) => {
  const footerText = `${label}${teamName ? ` ${teamName}` : ""}`.trim();
  const overlayStyle = {
    background:
      "radial-gradient(circle at 50% 40%, rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.35) 55%, rgba(0, 0, 0, 0.65) 100%), rgba(8, 11, 22, 0.68)",
  };
  const contentStyle = {
    gap: "clamp(18px, 3vw, 42px)",
    padding: "clamp(16px, 4vw, 72px) clamp(20px, 6vw, 120px)",
    transform: "translateY(-4vw)",
  };
  const dividerStyle = {
    background: `linear-gradient(90deg, rgba(255, 255, 255, 0.22) 0%, ${teamColor} 45%, ${teamColor} 55%, rgba(255, 255, 255, 0.22) 100%)`,
  };
  return (
    <div
      className="basketball-points-banner absolute inset-0 z-[1400] flex items-center justify-center text-white backdrop-blur"
      style={overlayStyle}
    >
      <div
        className="flex flex-col items-center text-center text-white"
        style={contentStyle}
      >
        {teamName && (
          <Text
            variant="basketballFlashBannerTeamName"
            className="font-extrabold uppercase tracking-[0.08em]"
            style={{ textShadow: "0 6px 22px rgba(0, 0, 0, 0.6)" }}
          >
            {teamName}
          </Text>
        )}
        <div
          className="h-[clamp(8px,1vw,14px)] w-[clamp(140px,24vw,340px)] rounded-full shadow-[0_10px_28px_rgba(0,0,0,0.45)]"
          style={dividerStyle}
        />
        <Text
          variant="basketballFlashBannerPoints"
          className="font-black leading-[0.82] tracking-[-0.02em]"
          style={{ textShadow: "0 18px 48px rgba(0, 0, 0, 0.7)" }}
        >
          {points}
        </Text>
        {footerText && (
          <Text
            variant="basketballFlashBannerFooterText"
            className="font-bold uppercase tracking-[0.05em] opacity-95"
            style={{ textShadow: "0 4px 18px rgba(0, 0, 0, 0.6)" }}
          >
            {footerText}
          </Text>
        )}
      </div>
    </div>
  );
};
